/**
 * Client session state relative to the HttpOnly session cookie.
 * The cookie cannot be read in JS; status is set by bootstrap (GET /users/current)
 * or by successful sign-in / sign-up responses.
 */
export enum AuthStatus {
  AUTHENTICATED = 'authenticated',
  PENDING = 'pending',
  UNAUTHENTICATED = 'unauthenticated',
}
